// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__ptUYx","afisha":"Avatar_afisha__8m5pW","first-letter":"Avatar_first-letter__55iRX","img":"Avatar_img__gSckh","img-default":"Avatar_img-default__NfXa7"};